import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import styles from '../styling/TransactionForm.module.css';
import { CATEGORIES } from '../helpers';
//TODO: UseSelector.map av categories - skapa options

function TransactionForm() {
  const [category, setCategory] = useState('');
  const [amount, setAmount] = useState('');
  const [name, setName] = useState('');

  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!category || !amount) {
      return 1;
    }

    dispatch({
      type: 'transactions/addTransaction',
      payload: { category: category, name: name, amount: amount, id: (Date.now().toString(36) + Math.floor(Math.pow(10, 12) + Math.random() * 9 * Math.pow(10, 12)).toString(36))}, // Generates unique id
    });
    setAmount('');
    setCategory('');
    setName('');
  };

  return (
    <div className={styles.div}>
      <h2 className={styles.h2}>Add Transaction</h2>

      <form onSubmit={handleSubmit} className={styles.form}>
        <label className={styles.label} htmlFor='name'>Name</label>
        <br />
        <input
          id='name'
          name='name'
          type='text'
          maxLength='50'
          onChange={(e) => setName(e.target.value)}
          value={name}
          required
          placeholder='Expense'
          autoComplete='off'
          className={styles.input}
        ></input>
        <br /> <br /> <br />

        {/* <label className={styles.label} htmlFor='category'>Category</label> */}
        <div className={styles.selectWrapper}>
        <select
          name='category'
          id='category'
          onChange={(e) => setCategory(e.target.value)}
          required
          className={styles.select}
          value={category}
        >
          <option key='defaultKey' value=''>Category</option>
          {CATEGORIES.map((category, i) => (
            <option key={i + 'Key'} value={category}>{category}</option>
          ))}
        </select>
        </div>
        <br /> <br /> <br />

        <label className={styles.label} htmlFor='amount'>Amount</label>
        <br />
        <input
          name='amount'
          min='0'
          max='100000000'
          type='number'
          id='amount'
          onChange={(e) => setAmount(e.target.value)}
          value={amount}
          placeholder='$100'
          required
          className={styles.input}
        ></input>
        <br /> <br /> <br />

        <button type='submit' className={styles.button}>
          Submit
        </button>
      </form>
    </div>
  );
}

export default TransactionForm;
